
<script>
import { compareVersion } from 'common/js/common'
import { MessageBox } from 'bxs-ui-vue'
Vue.use(MessageBox)

const errorMsg = '微信或系统版本过低，请升级后再尝试'

export default {
  name: 'OpenLaunch',
  props: {
    infor: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  created () {
    // iso15 && wx<8.0.8
    // 极少部分Android
    document.addEventListener('WeixinOpenTagsError', function (e) {
      console.error(e.detail.errMsg)
      this.$messagebox.alert(errorMsg)
    })
  },
  mounted () {
    // 需注册 openTagList: ['wx-open-launch-weapp']
    if (this.versionAbnormal()) {
      this.$messagebox.alert(errorMsg)
    } else {
      this.wxLaunchBtn()
    }
  },
  methods: {
    // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_Open_Tag.html#1
    versionAbnormal () {
      const ua = navigator.userAgent.toLowerCase()
      const isAndroid = window.appBridge && appBridge.isAndroid()
      const isIos = window.appBridge && appBridge.isIos()
      let wechatVersion, androidVersion, iosVersion
      wechatVersion = ua.match(/MicroMessenger\/([\d\.]+)/i)
      if (wechatVersion && wechatVersion[1]) {
        wechatVersion = wechatVersion[1]
      }
      // 微信版本要求为：7.0.12及以上
      if (compareVersion(wechatVersion, '7.0.12') === '<') {
        return true
      }
      if (isAndroid) {
        // Android version
        androidVersion = ua.match(/android (.*?);/)
        if (androidVersion && androidVersion[1]) {
          androidVersion = androidVersion[1].split('.')[0]
        }
        // Android 5.0及以上
        if (compareVersion(wechatVersion, '5.0') === '<') {
          return true
        }
      } else if (isIos) {
        // iOS version
        iosVersion = ua.match(/cpu iphone os (.*?) like mac os/)
        if (iosVersion && iosVersion[1] && iosVersion[1].split('_')) {
          iosVersion = iosVersion[1].split('_')[0]
        }
        // iOS 10.3及以上
        if (compareVersion(iosVersion, '10.3') === '<') {
          return true
        }
      }
      return false
    },
    wxLaunchBtn () {
      const { infor } = this
      if (!infor.originalId) {
        console.warn('originalId is empty')
        return
      }
      if (!infor.path) {
        console.warn('path is empty')
        return
      }
      const btnElm = this.$refs.openLaunch
      if (!btnElm) return
      const scriptElm = document.createElement('script')
      scriptElm.type = 'text/wxtag-template'
      scriptElm.text = infor.content
      const weappHTML = `<wx-open-launch-weapp username="${
        infor.originalId
      }" path="${infor.path}">${scriptElm.outerHTML}</wx-open-launch-weapp>`
      btnElm.innerHTML = weappHTML
      btnElm.addEventListener('launch', function (e) {
        console.log('launch success')
      })
      // 点击跳转 抛出异常
      btnElm.addEventListener('error', function (e) {
        console.log('launch fail', e.detail)
      })
    }
  }
}
</script>
<template>
  <div ref="openLaunch" class="open-lanuch-box" />
</template>
<style lang="postcss" scoped>
@import 'variable';
</style>


